export const CHUNK_WIDTH = 16;
export const CHUNK_DEPTH = 16;
export const CHUNK_HEIGHT = 256;
export const CHUNK_SIZE = CHUNK_WIDTH * CHUNK_DEPTH * CHUNK_HEIGHT;

export const SEA_LEVEL = 62;

export function blockIndex(x: number, y: number, z: number): number {
  return x + z * CHUNK_WIDTH + y * CHUNK_WIDTH * CHUNK_DEPTH;
}

export function worldToChunk(wx: number, wz: number): [number, number] {
  return [Math.floor(wx / CHUNK_WIDTH), Math.floor(wz / CHUNK_DEPTH)];
}

export function worldToLocal(wx: number, wz: number): [number, number] {
  return [((wx % CHUNK_WIDTH) + CHUNK_WIDTH) % CHUNK_WIDTH, ((wz % CHUNK_DEPTH) + CHUNK_DEPTH) % CHUNK_DEPTH];
}
